module.exports = __webpack_public_path__ + "static/media/solution-mindset-35bi.29b25198.svg";